export const TYPE_FAMILIES = [
  {
    id: "cries-of-the-heart",
    name: "Cries of the Heart",
    blurb: "Questions that give voice to grief, need, and wonder.",
    types: [
      ["Lament", "Questions cried out in grief or distress.", "An invitation to bring your hurt honestly, without pretending you are okay."],
      ["Complaint", "Questions that voice frustration or a grievance.", "An invitation to speak honestly and examine what your frustration reveals."],
      ["Intercessory", "Questions that plead with God on behalf of others.", "An invitation to carry someone else's need into prayer."],
      ["Request/Petition", "Questions that ask for help, wisdom, assurance, or a fair hearing.", "An invitation to name what you need and ask plainly."],
      ["Wonder/Awe", "Questions that marvel at God and His works.", "An invitation to stop, look up, and let wonder widen your view of God."],
    ],
  },
  {
    id: "questions-that-draw-us-out",
    name: "Questions That Draw Us Out",
    blurb: "Questions that begin a conversation, reveal the heart, or make an offer.",
    types: [
      ["Divine Initiative", "Questions through which God or Jesus starts the conversation.", "An invitation to hear the question as if it were spoken to you, and answer honestly."],
      ["Probing", "Questions that draw out what is really in the heart.", "An invitation to look honestly at what you love and what moves you."],
      ["Invitational", "Questions that make an offer or open a door.", "An invitation to notice what is being offered and decide whether to step through."],
    ],
  },
  {
    id: "questions-that-confront",
    name: "Questions That Confront",
    blurb: "Questions that press a claim, expose wrongdoing, or demand a response.",
    types: [
      ["Challenge", "Questions that confront or test the one asked and press for a stand.", "An invitation to ask where you stand and what you would say."],
      ["Accusatory", "Questions that charge someone with wrongdoing, rightly or wrongly.", "An invitation to weigh the charge fairly, owning real wrong without accepting false guilt."],
      ["Rebuking", "Questions that rebuke sin or folly.", "An invitation to turn around, so what is wrong can be made right."],
      ["Corrective", "Questions that set someone's thinking or conduct straight.", "An invitation to stay teachable and reconsider what you may have missed."],
      ["Cross-Examination", "Questions that press for facts, as in a trial.", "An invitation to examine the evidence, the motives behind the questioning, and what you believe for yourself."],
    ],
  },
  {
    id: "questions-that-teach",
    name: "Questions That Teach",
    blurb: "Questions that make a point, build understanding, or turn attention to deeper matters.",
    types: [
      ["Rhetorical", "Questions whose answer is already clear, asked to make a truth land.", "An invitation to say the answer out loud and let it settle your doubt."],
      ["Instructional", "Questions that teach by letting the listener reach the answer.", "An invitation to pause and answer the question yourself before reading on."],
      ["Wisdom/Philosophical", "Questions about life's meaning, its limits, and how to stand before God.", "An invitation to linger over what matters most."],
      ["Prophetic", "Questions that carry a prophet's message of warning, vision, or hope.", "An invitation to hear what God said to His people then, and what He may be showing you now."],
    ],
  },
  {
    id: "questions-that-seek",
    name: "Questions That Seek",
    blurb: "Questions that seek understanding, weigh choices, or turn inward.",
    types: [
      ["Genuine Inquiry", "Questions that sincerely want to know.", "An invitation to bring your own honest questions and keep seeking."],
      ["Deliberative", "Questions that weigh a decision or a course of action.", "An invitation to weigh your options, motives, and consequences before God."],
      ["Self-Reflective", "Questions asked of oneself, turning the light inward.", "An invitation to notice what you tell yourself, and whether it leads you toward hope in God."],
    ],
  },
].map((f) => ({ ...f, types: f.types.map(([name, definition, invitation]) => ({ name, definition, invitation })) }));

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");
